export default __webpack_public_path__ + "static/media/email.488579d5.svg";